const INFO = {
	main: {
		title: "Reactfolio by Pratyush",
		name: "Pratyush kumar Sinha",
		email: "pratyushksinha21@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		
		github: "https://github.com/pratyushcode",
		linkedin: "https://www.linkedin.com/in/pratyush-kumar-sinha-454a47225/",
		instagram: "https://instagram.com/party_yush",
		
	},

	homepage: {
		title: "I'm a visionary full-stack architect, crafting avant-garde digital experiences with precision.",
		description:
			

			"I'm currently pursuing my bachelor's degree in computer science and engineering from the Netaji Subash University of Technology, My primary interest lies in Full-Stack development,  problem-solving, and competitive programming. I have a great zeal to learn and to put all my skills and knowledge to get the best of my work done. Also, being a keen learner, I can work to the best of my potential faster and in a more relevant manner.",
	},
	
	about: {
		title:"I'm Pratyush Kumar Sinha, based in Delhi, India, on a mission to shape tomorrow's world.",
		description:
		"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},
	

	articles: {
		title: "I'm dedicated to exploring the uncharted realms of possibility and igniting the spark of innovation for future generations.",
		description:
		"A curated journey through my in-depth musings on programming, leadership, product design, and more, all arranged thematically.",
	},

	projects: [
		{
			title: "CarreerGuru",
			description:
				"Empowering individuals to chart their academic journey based on their passions and preferences, one course at a time.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Project",
			link: "https://github.com/pratyushcode/Carrer_guru",
		},

		{
			title: "ShadiWale.com",
			description:
				"ShadiWaale is a beautifully crafted WebApp built with the powerful combination of ReactJs and Django REST framework.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/pratyushcode/-ShaadiWale",
		},

		{
			title: "Portfolio",
			description:
				"Showcasing My Best,Unveiling Excellence, One Click at a Time.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/html/html.png",
			linkText: "View Project",
			link: "https://github.com",
		}

	
	],
};

export default INFO;
